export default __webpack_public_path__ + "static/media/Img156.98665379.jpg";